module.exports = __webpack_public_path__ + "img/goal-06.72c690fa.png";